import cx from 'classnames';

type Props = {
    fullWidth?: boolean;
    className?: string;
} & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export const Card: React.FC<Props> = ({children, className, fullWidth = true, ...rest}: Props) => (
    <div className={cx(className, {'tw-w-full': fullWidth}, 'tw-bg-light tw-p-4 tw-shadow-sm tw-rounded-sm')} {...rest}>
        {children}
    </div>
);
